import rrlog from '@meibao/traceback-record'
import {getBrowserType, getChromeVersion} from 'meibao-insure/src/util/commonUtils'
import {isIframe} from '@/util/channelUtil'
import router from '@/router/router'

//非谷歌浏览器，不给投保
export const huisuAble = {
	methods: {
		//判断是否有回溯
		isJudgeHuisu() {
			//获取cok
			//浏览器类型
			let isAbleBrow = getBrowserType()
			//浏览器版本
			let isAbleBrowVersion = getChromeVersion() < 90
			if (!isAbleBrow || isAbleBrowVersion || (rrlog.getState() !== 'visual' && !isIframe())) {
				//没有回溯需要的数据
				this.$confirm(
					'为了保证您投保过程流畅，以及投保数据的安全有效，请优先使用Edge浏览器或者谷歌浏览器，并且升级至最新版本！',
					'警告',
					{
						showCancelButton: false,
						showClose: false,
						closeOnClickModal: false,
						closeOnPressEscape: false,
						closeOnHashChange: false,
						center: true,
						type: 'error',
					},
				).then(() => {
					//退出当前页面！
					router.$avueRouter.closeTag()
					//返回上一页
					router.go(-1)
					// this.$store.dispatch('LogOut').then(() => {
					//   setStore({name: 'login', content: {forceRefresh: true}})
					//   this.$router.push({path: '/login'}).then(() => {})
					// })
				})
			}
		},
	},
}
